import React from "react";
import { withStyles } from "material-ui/styles";
import PropTypes from "prop-types";
import Typography from "material-ui/Typography";
import { ListItem, ListItemText } from "material-ui/List";
import { capitalize } from "./helpers/presentation.js";

const styles = theme => ({
  text: {
    marginLeft: 16,
    display: "flex",
    flexDirection: "row",
    alignItems: "baseline",
    justifyContent: "space-between"
  },
  alert: {
    color: theme.palette.secondary["700"]
  }
});

const Suggestion = props => {
  const { suggestion, classes, onClick } = props;

  const secondary = () => {
    if (suggestion.type === "user") {
      if (suggestion.secondary) {
        return (
          <Typography type="caption">
            {capitalize(suggestion.secondary)}
          </Typography>
        );
      } else {
        return (
          <Typography type="caption" className={classes.alert}>
            No account
          </Typography>
        );
      }
    }
  };

  if (!suggestion) {
    return null;
  }

  return (
    <ListItem dense button component="div" onClick={onClick}>
      <ListItemText
        primary={suggestion.text}
        secondary={secondary()}
        className={classes.text}
      />
    </ListItem>
  );
};
Suggestion.propTypes = {
  suggestion: PropTypes.object.isRequired,
  onClick: PropTypes.func
};

export { Suggestion };

export default withStyles(styles, { name: "Suggestion" })(Suggestion);



// WEBPACK FOOTER //
// ./src/Suggestion.js